module.exports = __webpack_public_path__ + "static/media/right_arrow.e52b5db1.svg";